<template>
  <div class="zdy-noe">
    <div :class="distinguish == 1 ? 'sulijy' : 'sulijy2'">
      <img :src="distinguish == 1 ? image : image1" @click="pitch(1)" alt="" />
      <span>设备</span>
    </div>
    <div :class="distinguish == 2 ? 'sulijy3' : 'sulijy1'">
      <img :src="distinguish == 2 ? image3 : image2" @click="pitch(2)" alt="" />
      <span>灾害模拟</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      distinguish: 1,
      image: require("../../../assets/sbdj.png"),
      image1: require("../../../assets/mrsb.png"),
      image2: require("../../../assets/zhmnmr.png"),
      image3: require("../../../assets/zhmndj.png"),
    };
  },
  methods: {
    pitch(i) {
      this.distinguish = i;
      // 传入colaright.vue ：灾害模拟
      this.emit.$emit("distinguish", this.distinguish);
    },
  },
};
</script>
<style lang="less" scoped>
.zdy-noe {
  width: 6vw;
  height: 4vh;
  position: absolute;
  left: 15%;
  bottom: 22%;
}
.sulijy {
  width: 4vw;
  height: 4vh;
  position: absolute;
  left: 7vw;
  bottom: 9vh;
  z-index: 3;
  transition: all 1s;
  transform: translateX(0%);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  img {
    width: 50%;
    height: auto;
  }
  span {
    display: block;
    color: #fff;
    font-size: 0.5vw;
  }
}
.sulijy2 {
  width: 4vw;
  height: 4vh;
  position: absolute;
  left: 7vw;
  bottom: 9vh;
  z-index: 3;
  transition: all 1s;
  transform: translateX(80%);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  img {
    width: 50%;
    height: auto;
  }
  span {
    display: block;
    color: #fff;
    font-size: 0.5vw;
  }
}

.sulijy1 {
  width: 4vw;
  height: 4vh;
  position: absolute;
  left: 10vw;
  bottom: 9vh;
  z-index: 3;
  transition: all 1s;
  transform: translateX(0%);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  img {
    width: 50%;
    height: auto;
  }
  span {
    display: flex;
    color: #fff;
    font-size: 0.5vw;
  }
}

.sulijy3 {
  width: 4vw;
  height: 4vh;
  position: absolute;
  left: 10vw;
  bottom: 9vh;
  z-index: 3;
  transition: all 1s;
  transform: translateX(-80%);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  img {
    width: 50%;
    height: auto;
  }
  span {
    display: flex;
    color: #fff;
    font-size: 0.5vw;
  }
}
</style>